module.exports = __webpack_public_path__ + "dotnet.e913aa.svg";